import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { subscriptionsAPI } from "../api";
import api from "../api";
import useAuthStore from "../store/auth";
import MobileMoneyModal from "../components/MobileMoneyModal";

const PLANS = {
  personal: {
    monthly: { amount: "2.99",  label: "/mois", interval: "personal_monthly" },
    yearly:  { amount: "49.99", label: "/an",   interval: "personal_yearly"  },
    features: ["1 utilisateur","Revenus et depenses illimites","Budgets mensuels","Rapports avances","Support standard"],
  },
  family: {
    monthly: { amount: "5.99",  label: "/mois", interval: "family_monthly" },
    yearly:  { amount: "89.99", label: "/an",   interval: "family_yearly"  },
    features: ["Jusqu a 10 membres","Tous beneficient du Premium","Dashboard familial partage","Budgets communs","Notifications temps reel","Support prioritaire"],
  },
};

// ── Composant Vanilla Pay Modal ───────────────────────────────
function VanillaPayModal({ interval, amount, onClose, onSuccess }) {
  const [step, setStep]       = useState("phone"); // phone | otp | success
  const [phone, setPhone]     = useState("");
  const [otp, setOtp]         = useState("");
  const [paymentId, setPaymentId] = useState(null);
  const [loading, setLoading] = useState(false);

  const inp = { width:"100%", background:"var(--surface2)", border:"1px solid var(--border)", borderRadius:10, padding:"12px 16px", color:"var(--text)", fontSize:16, outline:"none", boxSizing:"border-box", letterSpacing: step === "otp" ? 8 : 0, textAlign: step === "otp" ? "center" : "left" };

  const sendPayment = async () => {
    if (!phone.trim()) return toast.error("Entrez votre numero");
    setLoading(true);
    try {
      const { data } = await api.post("/vanillapay/create-payment", { interval, phone });
      setPaymentId(data.payment_id);
      setStep("otp");
      toast.success(data.message || "Code envoye sur votre telephone !");
    } catch (err) {
      toast.error(err.response?.data?.error || "Erreur Vanilla Pay");
    } finally { setLoading(false); }
  };

  const confirmOtp = async () => {
    if (!otp.trim()) return toast.error("Entrez le code OTP");
    setLoading(true);
    try {
      await api.post("/vanillapay/confirm-payment", { payment_id: paymentId, otp, interval });
      setStep("success");
      setTimeout(() => { onSuccess(); }, 2000);
    } catch (err) {
      toast.error(err.response?.data?.error || "Code incorrect ou expire");
    } finally { setLoading(false); }
  };

  return (
    <div style={{ position:"fixed", inset:0, background:"#00000090", zIndex:300, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ background:"var(--surface)", border:"1px solid var(--border)", borderRadius:20, padding:36, width:"100%", maxWidth:420, textAlign:"center" }}>
        {/* Logo Vanilla Pay */}
        <div style={{ width:64, height:64, borderRadius:"50%", background:"linear-gradient(135deg,#00c853,#00960f)", margin:"0 auto 16px", display:"flex", alignItems:"center", justifyContent:"center", fontSize:28 }}>
          📱
        </div>
        <h2 style={{ fontFamily:"Syne,sans-serif", fontWeight:800, marginBottom:4 }}>Vanilla Pay</h2>
        <p style={{ color:"var(--text2)", fontSize:14, marginBottom:24 }}>
          Paiement Mobile Money — <strong style={{ color:"var(--accent3)" }}>${amount}</strong>
        </p>

        {step === "phone" && (
          <>
            <div style={{ background:"#00c85320", border:"1px solid #00c85340", borderRadius:12, padding:14, marginBottom:20, fontSize:13, color:"#00c853" }}>
              Entrez votre numero MVola, Orange Money ou Airtel Money. Vous recevrez un code de confirmation par SMS.
            </div>
            <div style={{ marginBottom:20, textAlign:"left" }}>
              <label style={{ display:"block", fontSize:13, color:"var(--text2)", marginBottom:8 }}>Numero de telephone</label>
              <input value={phone} onChange={e => setPhone(e.target.value)} placeholder="034 XX XXX XX" style={inp} />
            </div>
            <div style={{ display:"flex", gap:12 }}>
              <button onClick={onClose} style={{ flex:1, padding:14, background:"var(--surface2)", border:"1px solid var(--border)", borderRadius:10, cursor:"pointer", color:"var(--text)" }}>Annuler</button>
              <button onClick={sendPayment} disabled={loading}
                style={{ flex:2, padding:14, background:"linear-gradient(135deg,#00c853,#00960f)", color:"#fff", border:"none", borderRadius:10, fontFamily:"Syne,sans-serif", fontWeight:700, cursor:"pointer", opacity:loading?0.7:1 }}>
                {loading ? "Envoi en cours..." : "Envoyer le code"}
              </button>
            </div>
          </>
        )}

        {step === "otp" && (
          <>
            <div style={{ background:"#00c85320", border:"1px solid #00c85340", borderRadius:12, padding:14, marginBottom:20, fontSize:13, color:"#00c853" }}>
              Un code OTP a ete envoye au <strong>{phone}</strong>. Entrez-le ci-dessous pour confirmer le paiement.
            </div>
            <div style={{ marginBottom:20, textAlign:"left" }}>
              <label style={{ display:"block", fontSize:13, color:"var(--text2)", marginBottom:8 }}>Code OTP</label>
              <input value={otp} onChange={e => setOtp(e.target.value)} placeholder="XXXXXX" maxLength={8} style={inp} />
            </div>
            <div style={{ display:"flex", gap:12 }}>
              <button onClick={() => setStep("phone")} style={{ flex:1, padding:14, background:"var(--surface2)", border:"1px solid var(--border)", borderRadius:10, cursor:"pointer", color:"var(--text)" }}>Retour</button>
              <button onClick={confirmOtp} disabled={loading}
                style={{ flex:2, padding:14, background:"linear-gradient(135deg,#00c853,#00960f)", color:"#fff", border:"none", borderRadius:10, fontFamily:"Syne,sans-serif", fontWeight:700, cursor:"pointer", opacity:loading?0.7:1 }}>
                {loading ? "Verification..." : "Confirmer le paiement"}
              </button>
            </div>
          </>
        )}

        {step === "success" && (
          <>
            <div style={{ fontSize:64, marginBottom:16 }}>✅</div>
            <h3 style={{ fontFamily:"Syne,sans-serif", fontWeight:800, color:"var(--accent3)", marginBottom:8 }}>Paiement confirme !</h3>
            <p style={{ color:"var(--text2)" }}>Votre compte Premium est maintenant actif.</p>
          </>
        )}
      </div>
    </div>
  );
}

// ── Page Pricing principale ───────────────────────────────────
export default function PricingPage() {
  const { t } = useTranslation();
  const { user, fetchMe, isPremium, isTrialActive, trialDaysLeft, isViaFamilyPlan, isFamilyReadOnly } = useAuthStore();
  const navigate = useNavigate();
  const [billing,  setBilling]  = useState("monthly");
  const [planType, setPlanType] = useState("personal");
  const [step,     setStep]     = useState("plans"); // plans | paypal | vanilla
  const [loading,  setLoading]  = useState(false);
  const [showVanilla, setShowVanilla]   = useState(false);
  const [showMobileMoney, setShowMobileMoney] = useState(false);
  const paypalRef      = useRef(null);
  const paypalRendered = useRef(false);

  const trialDays = trialDaysLeft();
  const selected  = PLANS[planType][billing];
  const isPersonalPremium = isPremium() && user?.account_type !== "family";
  const isFamilyPremiumActive  = isPremium() && user?.account_type === "family";

  useEffect(() => {
    if (step !== "paypal") return;
    if (paypalRendered.current) return;
    const clientId = process.env.REACT_APP_PAYPAL_CLIENT_ID;
    if (!clientId) { toast.error("PayPal non configure"); return; }
    const existing = document.getElementById("paypal-sdk");
    if (existing) { renderPayPalButton(); return; }
    const script = document.createElement("script");
    script.id = "paypal-sdk";
    script.src = "https://www.paypal.com/sdk/js?client-id=" + clientId + "&currency=USD&intent=capture";
    script.async = true;
    script.onload = renderPayPalButton;
    document.body.appendChild(script);
  }, [step]);

  const renderPayPalButton = () => {
    if (!window.paypal || !paypalRef.current || paypalRendered.current) return;
    paypalRendered.current = true;
    window.paypal.Buttons({
      style: { layout:"vertical", color:"blue", shape:"rect", label:"pay", height:50 },
      createOrder: async () => {
        setLoading(true);
        try {
          const { data } = await subscriptionsAPI.createOrder({ interval: selected.interval });
          return data.order_id;
        } catch (err) { toast.error(err.response?.data?.error || "Erreur"); throw err; }
        finally { setLoading(false); }
      },
      onApprove: async (data) => {
        setLoading(true);
        try {
          await subscriptionsAPI.captureOrder({ order_id: data.orderID, interval: selected.interval });
          await fetchMe();
          toast.success(t("payment_success"));
          const endsAt = new Date();
          if (billing === "yearly") endsAt.setFullYear(endsAt.getFullYear() + 1);
          else endsAt.setMonth(endsAt.getMonth() + 1);
          navigate("/receipt", { state: { receipt: {
            plan: "Premium " + (planType === "family" ? "Familial" : "Personnel") + " " + (billing === "monthly" ? "Mensuel" : "Annuel"),
            amount: selected.amount, currency: "USD",
            date: new Date().toLocaleDateString("fr-FR"),
            orderId: data.orderID,
            validUntil: endsAt.toLocaleDateString("fr-FR"),
          }}});
        } catch (err) { toast.error(err.response?.data?.error || "Erreur"); }
        finally { setLoading(false); }
      },
      onError:  () => { toast.error("Erreur PayPal."); setLoading(false); },
      onCancel: () => { toast("Annule."); setLoading(false); },
    }).render(paypalRef.current);
  };

  const handleVanillaSuccess = async () => {
    await fetchMe();
    navigate("/dashboard?payment=success");
  };

  if (step === "paypal") return (
    <div style={{ minHeight:"100vh", background:"var(--bg)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ background:"var(--surface)", border:"1px solid var(--border)", borderRadius:20, padding:40, width:"100%", maxWidth:460 }}>
        <button onClick={() => { setStep("plans"); paypalRendered.current = false; }} style={{ background:"none", border:"none", color:"var(--text2)", fontSize:14, marginBottom:24, cursor:"pointer" }}>← {t("back")}</button>
        <h2 style={{ fontFamily:"Syne,sans-serif", fontWeight:700, marginBottom:4 }}>Payer avec PayPal</h2>
        <p style={{ color:"var(--text2)", fontSize:13, marginBottom:20 }}>
          Premium {planType === "family" ? "Familial" : "Personnel"} · {billing === "monthly" ? "Mensuel" : "Annuel"}
        </p>
        <div style={{ fontFamily:"Syne,sans-serif", fontSize:40, fontWeight:800, color:"var(--accent)", marginBottom:24 }}>
          {selected.amount}$ <span style={{ fontSize:16, color:"var(--text2)", fontWeight:400 }}>{selected.label}</span>
        </div>
        {loading && <p style={{ textAlign:"center", color:"var(--text2)", marginBottom:16 }}>Chargement...</p>}
        <div ref={paypalRef} id="paypal-button-container" />
        <p style={{ textAlign:"center", marginTop:16, fontSize:12, color:"var(--text3)" }}>🔒 Paiement securise via PayPal</p>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight:"100vh", background:"var(--bg)", display:"flex", flexDirection:"column", alignItems:"center", padding:"60px 20px" }}>
      <div style={{ textAlign:"center", marginBottom:40 }}>
        <div style={{ fontFamily:"Syne,sans-serif", fontSize:28, fontWeight:800, background:"linear-gradient(135deg,#7c6af7,#f7c26a)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", marginBottom:8 }}>BudgetFlow</div>
        <h1 style={{ fontFamily:"Syne,sans-serif", fontSize:34, fontWeight:800, color:"var(--text)", marginBottom:16 }}>{t("pricing_title")}</h1>
        {user && !isPremium() && isTrialActive() && (
          <div style={{ display:"inline-block", padding:"8px 20px", background:"#6af7b820", border:"1px solid #6af7b840", borderRadius:20, color:"var(--accent3)", fontSize:14, fontWeight:600 }}>
            🕐 {trialDays} {t("pricing_trial_badge")}
          </div>
        )}
        {user && !isPremium() && !isTrialActive() && (
          <div style={{ display:"inline-block", padding:"8px 20px", background:"#f76a6a20", border:"1px solid #f76a6a40", borderRadius:20, color:"var(--danger)", fontSize:14, fontWeight:600 }}>
            ❌ {t("pricing_trial_expired")}
          </div>
        )}
        {user && isPremium() && !isViaFamilyPlan() && (
          <div style={{ display:"inline-block", padding:"8px 20px", background:"#7c6af720", border:"1px solid #7c6af740", borderRadius:20, color:"var(--accent)", fontSize:14, fontWeight:600 }}>
            ⭐ Vous etes deja Premium
          </div>
        )}
      </div>

      {/* Switchers */}
      <div style={{ display:"flex", gap:12, marginBottom:32, flexWrap:"wrap", justifyContent:"center" }}>
        <div style={{ display:"flex", background:"var(--surface)", padding:4, borderRadius:12, border:"1px solid var(--border)", gap:4 }}>
          {["monthly","yearly"].map(i => (
            <button key={i} onClick={() => setBilling(i)} style={{ padding:"10px 24px", borderRadius:8, border:"none", background:billing===i?"var(--accent)":"transparent", color:billing===i?"#fff":"var(--text2)", fontFamily:"Syne,sans-serif", fontWeight:600, fontSize:14, cursor:"pointer" }}>
              {i === "monthly" ? t("monthly") : t("yearly")}
              {i === "yearly" && <span style={{ marginLeft:8, fontSize:11, background:"#6af7b830", color:"var(--accent3)", padding:"2px 8px", borderRadius:20 }}>-17%</span>}
            </button>
          ))}
        </div>
        <div style={{ display:"flex", background:"var(--surface)", padding:4, borderRadius:12, border:"1px solid var(--border)", gap:4 }}>
          <button onClick={() => setPlanType("personal")} style={{ padding:"10px 20px", borderRadius:8, border:"none", background:planType==="personal"?"#7c6af7":"transparent", color:planType==="personal"?"#fff":"var(--text2)", fontFamily:"Syne,sans-serif", fontWeight:600, fontSize:14, cursor:"pointer" }}>👤 Personnel</button>
          <button onClick={() => setPlanType("family")} style={{ padding:"10px 20px", borderRadius:8, border:"none", background:planType==="family"?"#f7c26a":"transparent", color:planType==="family"?"#1a1a00":"var(--text2)", fontFamily:"Syne,sans-serif", fontWeight:600, fontSize:14, cursor:"pointer" }}>👨‍👩‍👧 Familial</button>
        </div>
      </div>

      <div style={{ display:"grid", gridTemplateColumns: user ? "1fr" : "repeat(auto-fit,minmax(280px,1fr))", gap:24, width:"100%", maxWidth: user ? 520 : 740 }}>
        {/* Essai gratuit — visiteurs non connectes uniquement */}
        {!user && (
          <div style={{ background:"var(--surface)", border:"1px solid var(--border)", borderRadius:20, padding:32 }}>
            <div style={{ fontSize:13, color:"var(--accent3)", fontWeight:700, letterSpacing:1, marginBottom:6 }}>ESSAI GRATUIT</div>
            <div style={{ fontFamily:"Syne,sans-serif", fontSize:38, fontWeight:800, marginBottom:4 }}>15 jours</div>
            <div style={{ fontSize:13, color:"var(--text3)", marginBottom:28 }}>Sans carte bancaire</div>
            {["Acces complet 15 jours","Personnel et Familial","Aucun engagement"].map(f => (
              <div key={f} style={{ display:"flex", gap:8, marginBottom:10, fontSize:14, color:"var(--text2)" }}>
                <span style={{ color:"var(--accent3)" }}>✓</span>{f}
              </div>
            ))}
            <button onClick={() => navigate("/register")} style={{ width:"100%", marginTop:24, padding:14, background:"var(--surface2)", color:"var(--text)", border:"1px solid var(--border)", borderRadius:12, fontFamily:"Syne,sans-serif", fontWeight:700, fontSize:15, cursor:"pointer" }}>
              {t("start_free")}
            </button>
          </div>
        )}

        {/* Plan Premium */}
        <div style={{ background:"var(--surface)", border:"2px solid var(--accent)", borderRadius:20, padding:32, position:"relative", boxShadow:"0 0 40px #7c6af730" }}>
          <div style={{ position:"absolute", top:-13, left:"50%", transform:"translateX(-50%)", background:"linear-gradient(135deg,var(--accent),var(--accent2))", color:"#fff", padding:"4px 18px", borderRadius:20, fontSize:12, fontWeight:700, whiteSpace:"nowrap" }}>
            {planType === "family" ? "👨‍👩‍👧 FAMILIAL" : "👤 PERSONNEL"}
          </div>
          <div style={{ fontSize:13, color:"var(--accent)", fontWeight:700, letterSpacing:1, marginBottom:6 }}>PREMIUM</div>
          <div style={{ display:"flex", alignItems:"baseline", gap:4, marginBottom:4 }}>
            <span style={{ fontFamily:"Syne,sans-serif", fontSize:38, fontWeight:800, color:"var(--accent)" }}>{selected.amount}$</span>
            <span style={{ fontSize:15, color:"var(--text2)" }}>{selected.label}</span>
          </div>
          <div style={{ fontSize:13, color:"var(--text3)", marginBottom:20 }}>PayPal · Visa · Mastercard · Mobile Money</div>
          {PLANS[planType].features.map(f => (
            <div key={f} style={{ display:"flex", gap:8, marginBottom:10, fontSize:14, color:"var(--text)" }}>
              <span style={{ color:"var(--accent)" }}>⭐</span>{f}
            </div>
          ))}
          {isPersonalPremium && planType === "family" && (
            <div style={{ background:"#7c6af720", border:"1px solid #7c6af740", borderRadius:10, padding:12, marginTop:12, fontSize:13, color:"var(--accent3)" }}>
              ℹ️ Votre abonnement Personnel reste actif. Le Familial sera independant.
            </div>
          )}

          {/* Boutons de paiement */}
          {!isPremium() || (isPersonalPremium && planType === "family") || (isFamilyPremiumActive && planType === "personal") ? (
            <div style={{ marginTop:24, display:"grid", gap:10 }}>
              {/* PayPal */}
              <button onClick={() => { if (!user) { navigate("/register"); return; } setStep("paypal"); }}
                style={{ width:"100%", padding:14, background:"#0070ba", color:"#fff", border:"none", borderRadius:12, fontFamily:"Syne,sans-serif", fontWeight:700, fontSize:15, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:10 }}>
                <span style={{ fontSize:20 }}>🅿️</span> Payer avec PayPal
              </button>
              {/* Mobile Money manuel */}
              <button onClick={() => { if (!user) { navigate("/register"); return; } setShowMobileMoney(true); }}
                style={{ width:"100%", padding:14, background:"linear-gradient(135deg,#e60000,#ff6600)", color:"#fff", border:"none", borderRadius:12, fontFamily:"Syne,sans-serif", fontWeight:700, fontSize:15, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:10 }}>
                <span style={{ fontSize:20 }}>📱</span> Payer par Mobile Money (MVola / Orange)
              </button>
              <p style={{ textAlign:"center", fontSize:12, color:"var(--text3)" }}>🔒 MVola · Orange Money · Activation sous 24h</p>
            </div>
          ) : (
            <div style={{ marginTop:24, padding:14, background:"var(--surface2)", borderRadius:12, textAlign:"center", color:"var(--text2)", fontSize:14 }}>
              {isFamilyPremiumActive && planType === "family" ? "⭐ Deja Premium Familial" :
               isPersonalPremium && planType === "personal" ? "⭐ Deja Premium Personnel" : "⭐ Deja Premium"}
            </div>
          )}
        </div>
      </div>

      {/* Modal Mobile Money */}
      {showMobileMoney && (
        <MobileMoneyModal
          interval={selected.interval}
          amountUSD={parseFloat(selected.amount)}
          amountAriary={selected.interval === "personal_monthly" ? 13500 : selected.interval === "personal_yearly" ? 225000 : selected.interval === "family_monthly" ? 27000 : 405000}
          planLabel={"Premium " + (planType === "family" ? "Familial" : "Personnel") + " " + (billing === "monthly" ? "Mensuel" : "Annuel")}
          onClose={() => setShowMobileMoney(false)}
          onSuccess={() => { setShowMobileMoney(false); navigate("/dashboard"); }}
        />
      )}
    </div>
  );
}